<div class="wrapper">
  <app-top-line></app-top-line>

  <app-header></app-header>

  <app-header-menu></app-header-menu>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</div>
<app-modals-block></app-modals-block>
